import type { TaskArgumentsV0 } from './migrationV0';
import type { TaskPropertiesV1 } from './migrationV1';

export const convertFromJsonSerializableOutput = (
  input: unknown,
  parentKey: string = ''
): TaskPropertiesV1['taskParameters'] => {
  let result: TaskPropertiesV1['taskParameters'] = {};

  if (
    typeof input === 'boolean' ||
    typeof input === 'number' ||
    typeof input === 'string'
  ) {
    result[parentKey] = input;
  } else if (Array.isArray(input)) {
    // Skip arrays
  } else if (typeof input === 'object' && input !== null) {
    for (const [key, value] of Object.entries(input)) {
      const nestedResult = convertFromJsonSerializableOutput(value, key);
      result = {
        ...result,
        ...nestedResult,
      };
    }
  }
  // Skip null values

  return result;
};

export const convertToTaskParameters = (
  input: TaskArgumentsV0
): TaskPropertiesV1['taskParameters'] => {
  const staticParameters: TaskPropertiesV1['taskParameters'] = Object.entries(
    input.static
  ).reduce(
    (acc, [key, value]) => ({
      ...acc,
      ...convertFromJsonSerializableOutput(value, key),
    }),
    {}
  );

  return {
    ...staticParameters,
    ...input.shared,
  };
};
